import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React, { useState } from 'react';

import { MainTab } from '../CompanyProfileTabs/MainTab';
import { a11yProps, getTabByCode } from './helpers';
import { CompanyProfileTabsStyledContainer } from './StyledComponents';

interface CompanyProfileTabsContainerProps {
  mainData: MainData;
  isInspection: boolean;
  isAllowEdit: boolean;
  onChangeInspection: (value: boolean) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const CompanyProfileTabsContainer = ({
  mainData,
  isInspection,
  isAllowEdit,
  onChangeInspection,
}: CompanyProfileTabsContainerProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  return (
    <>
      <CompanyProfileTabsStyledContainer>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={activeTabIndex}
          onChange={(_, v) => setActiveTabIndex(v)}
          className={'root-company-profile-tabs'}
        >
          {mainData.tabs.map((tab, index) => (
            <Tab key={index} label={tab.title} {...a11yProps(index)} />
          ))}
        </Tabs>
        <div className="root-company-profile-tabs__wrapper">
          <CustomTabPanel value={activeTabIndex} index={0}>
            <MainTab
              mainData={mainData}
              isAllowEdit={isAllowEdit}
              isInspection={isInspection}
              onChangeInspection={onChangeInspection}
            />
          </CustomTabPanel>
          {mainData.tabs.slice(1).map((tab, index) => (
            <CustomTabPanel key={tab.code} value={activeTabIndex} index={index + 1}>
              {getTabByCode({ code: tab.code, isAllowEdit })}
            </CustomTabPanel>
          ))}
        </div>
      </CompanyProfileTabsStyledContainer>
    </>
  );
};

export { CompanyProfileTabsContainer };
